import type { useApi } from '@/plugins/api'

import { createPinia } from 'pinia'

export default function (api: typeof useApi) {
  const pinia = createPinia()

  pinia.use(api)

  return pinia
}
